import { Backdrop, createStyles, makeStyles, Theme } from "@material-ui/core";
import GlydeLoading from "../../assets/icons/glyde-loading.gif";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    backdrop: {
      zIndex: 9999,
      color: "#fff",
    },
    loadingGif: {
      width: "50px",
      height: "50px",
    },
  })
);

interface CustomProps {
  isLoading: boolean;
}

const GlydeBackdrop = (props: CustomProps) => {
  const classes = useStyles();

  return (
    <Backdrop open={props.isLoading} className={classes.backdrop}>
      <img
        src={GlydeLoading}
        alt="glyde-loading-gif"
        className={classes.loadingGif}
      />
    </Backdrop>
  );
};

export default GlydeBackdrop;
